export { DesignPagination } from './DesignPagination';
export type { DesignPaginationProps } from './DesignPagination';
